import React from 'react';
import ConsolidatedPosition from '../pages/ConsolidatedPosition';

export const consolidatedPositionRoutePage = {
  component: <ConsolidatedPosition />,
  route: '/posicao-consolidada',
};
